import { ProjectVersion } from "../API";
import { encodeFlowDiagramSourceHandles } from "../utils/flowDiagramSourceHandle";

function hasPatchField<T extends object>(patch: T, field: keyof T): boolean {
  return Object.prototype.hasOwnProperty.call(patch, field);
}

export function mergeProjectVersionSubscriptionPatch(
  currentWorkspaceVersion: ProjectVersion | null | undefined,
  partialProjectInDb: ProjectVersion
): ProjectVersion | null {
  if (!currentWorkspaceVersion) {
    return null;
  }

  const workspaceVersion = JSON.parse(
    JSON.stringify(currentWorkspaceVersion)
  ) as ProjectVersion;

  if (hasPatchField(partialProjectInDb, "videoParts")) {
    workspaceVersion.videoParts = partialProjectInDb.videoParts;
  }
  if (hasPatchField(partialProjectInDb, "stateJsonSchemaStr")) {
    workspaceVersion.stateJsonSchemaStr = partialProjectInDb.stateJsonSchemaStr;
  }
  if (hasPatchField(partialProjectInDb, "settingsJsonSchemaStr")) {
    workspaceVersion.settingsJsonSchemaStr =
      partialProjectInDb.settingsJsonSchemaStr;
  }
  if (hasPatchField(partialProjectInDb, "settings")) {
    workspaceVersion.settings = partialProjectInDb.settings;
  }
  if (hasPatchField(partialProjectInDb, "experiments")) {
    workspaceVersion.experiments = partialProjectInDb.experiments;
  }
  if (hasPatchField(partialProjectInDb, "flowDiagram")) {
    workspaceVersion.flowDiagram = encodeFlowDiagramSourceHandles(
      partialProjectInDb.flowDiagram
    );
  }
  if (hasPatchField(partialProjectInDb, "fontOverrides")) {
    workspaceVersion.fontOverrides = partialProjectInDb.fontOverrides;
  }
  workspaceVersion.updatedAt = partialProjectInDb.updatedAt;

  return workspaceVersion;
}
